import { ExternalLink, ImageOff } from "lucide-react";

const ISSUES = [
  {
    number: "006",
    date: "Octobre 2022",
    featured: "Pr Wounfa Jean-Marie",
    cover: "/gazette/n006.jpg",
    calameo: "https://www.calameo.com/books/007020483094d7588fe0a",
  },
  {
    number: "005",
    date: "Juin 2022",
    featured: "Claude-Bernard Elio Alceus",
    cover: "/gazette/n005.jpg",
    calameo: "https://www.calameo.com/books/0070204838893a4d58cbb",
  },
  {
    number: "004",
    date: "Mars 2022",
    featured: "Dr Yadji Paul",
    cover: "/gazette/n004.jpg",
    calameo: "https://www.calameo.com/books/007020483e815d7d4bf20",
  },
  {
    number: "003",
    date: "Décembre 2021",
    featured: "Jean-Claude Nkodo Essomba",
    cover: "/gazette/n003.jpg",
    calameo: "https://www.calameo.com/books/007020483bb4eb52ef129",
  },
  {
    number: "002",
    date: "Septembre 2021",
    featured: "Daouda Mbouobouo",
    cover: "/gazette/n002.jpg",
    calameo: "https://www.calameo.com/books/007020483b363bedbb28c",
  },
  {
    number: "001",
    date: "Juin 2021",
    featured: "Marie Lissouck",
    cover: "/gazette/n001.jpg",
    calameo: "https://www.calameo.com/books/007020483f75c9b15e639",
  },
];

export default function Gazette() {
  return (
    <div data-testid="page-gazette" className="pt-32 pb-20 px-6 md:px-12 lg:px-24 min-h-screen">
      <header className="mb-20 max-w-4xl">
        <p className="text-xs tracking-[0.3em] uppercase text-[#9E4735] font-body mb-6">
          Bulletin trimestriel
        </p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-[#1A1A1A] leading-[1.05] tracking-tight font-light mb-8">
          La <em className="text-[#2C402E]">Gazette</em> CLED
        </h1>
        <p className="text-lg text-[#4A4A4A] font-body leading-relaxed max-w-2xl">
          Le bulletin d'information des livres et des auteurs africains.
          Chaque trimestre, interviews exclusives, portraits d'auteurs, recensions
          d'ouvrages et actualités de la maison d'édition.
        </p>
      </header>

      <div
        data-testid="gazette-issues-grid"
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-14"
      >
        {ISSUES.map((issue, i) => (
          <article
            key={issue.number}
            data-testid={`gazette-issue-${issue.number}`}
            className="group fade-in-up"
            style={{ animationDelay: `${i * 80}ms` }}
          >
            <a
              href={issue.calameo}
              target="_blank"
              rel="noreferrer"
              data-testid={`gazette-link-${issue.number}`}
              className="block"
            >
              <div className="aspect-[3/4] overflow-hidden bg-[#F4F1EA] mb-5 relative border border-[#D1CFC7]">
                {issue.cover ? (
                  <img
                    src={issue.cover}
                    alt={`Gazette CLED N°${issue.number}`}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                  />
                ) : (
                  <div className="w-full h-full flex flex-col items-center justify-center text-[#757575] p-6 text-center bg-[#F4F1EA]">
                    <ImageOff size={32} className="mb-3" />
                    <p className="font-serif text-xl text-[#2C402E]">N°{issue.number}</p>
                    <p className="text-xs font-body mt-2">Couverture à venir</p>
                  </div>
                )}
                <div className="absolute inset-0 bg-[#1A1A1A]/0 group-hover:bg-[#1A1A1A]/30 transition-colors flex items-center justify-center">
                  <span className="opacity-0 group-hover:opacity-100 transition-opacity bg-[#FAF9F6] text-[#1A1A1A] px-4 py-2 font-body text-sm flex items-center gap-2">
                    <ExternalLink size={14} /> Lire sur Calameo
                  </span>
                </div>
              </div>
            </a>
            <p className="text-[10px] tracking-[0.25em] uppercase font-body text-[#9E4735] mb-2">
              Numéro {issue.number} · {issue.date}
            </p>
            <h3 className="font-serif text-2xl text-[#1A1A1A] leading-tight mb-2">
              {issue.featured}
            </h3>
            <a
              href={issue.calameo}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-sm text-[#2C402E] font-body link-underline"
            >
              Lire la gazette <ExternalLink size={14} />
            </a>
          </article>
        ))}
      </div>

      <section className="mt-24 border-t border-[#D1CFC7] pt-16">
        <h2 className="font-serif text-3xl text-[#1A1A1A] font-light mb-4">
          Vous souhaitez nous rejoindre ?
        </h2>
        <p className="text-base font-body text-[#4A4A4A] max-w-2xl mb-6">
          La Gazette accueille interviews, recensions et chroniques de plumes
          francophones. Pour proposer une contribution, écrivez-nous à
          challengeslitteraires.editions@gmail.com.
        </p>
      </section>
    </div>
  );
}
